import {
  IconButton,
  Paper,
  Fab,
  Switch,
  CircularProgress,
} from "@material-ui/core";
import { DataGrid } from "@material-ui/data-grid";
import { DeleteOutline, Create } from "@material-ui/icons";
import AddIcon from "@material-ui/icons/Add";
import styled from "styled-components";

export const Container = styled(Paper)`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  padding: 28px;

  height: 82vh;

  h2 {
    margin-bottom: 30px;
  }
`;
export const Button = styled(IconButton)``;

export const EditIcon = styled(Create)``;

export const DeleteIcon = styled(DeleteOutline)``;

export const ShowTagSwitch = styled(Switch)``;

export const TagsManagerTitle = styled.h1``;

export const TagsManagerTable = styled(DataGrid)``;

export const CreateTagContainer = styled.div`
  align-self: flex-end;
  margin-top: 28px;
`;
export const CreateTagButton = styled(Fab)``;

export const CreateTagIcon = styled(AddIcon)``;

export const LoadingContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Loading = styled(CircularProgress).attrs({
  size: "38px",
})`
  color: #3d9be9;
  justify-content: center;
`;
